import { scaleSequential } from 'd3';
import React, { useLayoutEffect } from 'react';
import { useHookWithRefCallback } from '../../../utils/hooks/useHookWithRefCallback';
import { interpolateColour } from '../utils/interpolateColour';

interface SpectraHeatmapProps {
    minValue: number;
    maxValue: number;
    canvasWidth: number;
    canvasHeight: number;
    xyValues: (number | null)[][];
    leftOffset: number;
    topOffset: number;
    blur: number;
}
const SpectraHeatmap = ({ canvasHeight, canvasWidth, minValue, maxValue, xyValues, leftOffset, topOffset, blur }: SpectraHeatmapProps) => {
    const [canvas, setCanvas] = useHookWithRefCallback<HTMLCanvasElement>();

    const rectanglePaddingX = 0.4;
    const rectanglePaddingY = 0.4;

    useLayoutEffect(() => {
        if (!canvas) {
            return;
        }
        const xDimensionLength = xyValues.length;
        const yDimensionLength = xyValues[0]?.length;

        const ctx = canvas.getContext('2d')!;
        const xStep = canvasWidth / xDimensionLength;
        const yStep = canvasHeight / yDimensionLength;

        const colourScale = scaleSequential().domain([minValue, maxValue]).interpolator(interpolateColour);

        // render spectra on a canvas
        for (let x = 0; x < xDimensionLength; x++) {
            for (let y = 0; y < yDimensionLength; y++) {
                const value = xyValues[x][y];
                if (value === null) ctx.fillStyle = 'black';
                else ctx.fillStyle = colourScale(value);
                ctx.fillRect(x * xStep - rectanglePaddingX, y * yStep - rectanglePaddingY, xStep + rectanglePaddingX * 2, yStep + rectanglePaddingY * 2);
            }
        }
    }, [canvas, maxValue, canvasHeight, canvasWidth, xyValues]);

    return (
        <div
            style={{
                width: canvasWidth,
                height: canvasHeight,
                background: interpolateColour(0),
                position: 'absolute',
                left: leftOffset,
                top: topOffset,
                overflow: 'hidden',
            }}
        >
            <canvas style={{ filter: `blur(${blur}px)` }} width={canvasWidth} height={canvasHeight} ref={setCanvas} />
        </div>
    );
};

export default SpectraHeatmap;
